import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import RegistrationForm from "@/pages/RegistrationForm";
import UploadBukti from "@/pages/UploadBukti";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/barat" element={<RegistrationForm />} />
          <Route path="/barat/upload" element={<UploadBukti />} />
          <Route path="/barat/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
